import {
    Button,
    Card,
    CardContent,
    CardFooter,
    CardHeader,
    Icons,
} from '@toppy-webshop/toppy-design-system';
import {
    ItemsSelectionState,
    Order,
    OrderItem,
    useSupportCaseStore,
} from '../../../store/supportCaseStore';
import {Item} from './Item';
import {useState} from 'react';
import styles from './rootQuestion.module.css';

interface ItemsSelectorProps {
    state: ItemsSelectionState;
    stateIndex: number;
    questionOrderNumber: number;
    cardsLayout?: boolean;
    qtyRequired?: boolean;
}

export const ItemsSelector = ({
    state,
    questionOrderNumber,
    cardsLayout = false,
}: ItemsSelectorProps) => {
    const order = useSupportCaseStore(
        state => state.supportCase?.order
    ) as Order;

    const [selectedItems, setSelectedItems] = useState<
        Array<{
            item: OrderItem;
            qty: number | null;
        }>
    >([]);
    const setStateItems = useSupportCaseStore(state => state.setStateItems);
    const [isLoading, setLoading] = useState<boolean>(false);
    const isAnswered = state.items.length > 0;

    return (
        <Card shadow={cardsLayout ? undefined : 'none'} noMargin={!cardsLayout}>
            <CardHeader
                noBorder={isAnswered}
                noHorizontalPadding={!cardsLayout}
                noMargin={!cardsLayout}
            >
                <div className={styles.headerWrapper}>
                    <span className={styles.number}>{questionOrderNumber}</span>{' '}
                    Over welk(e) product(en) gaat het?
                </div>
            </CardHeader>
            {!isAnswered && (
                <CardContent>
                    {order.orderItems
                        .filter(item => item.allowShipment)
                        .map((item, index) => {
                            return (
                                <Item
                                    item={item}
                                    key={item.id}
                                    requireQty={state.qtyRequired}
                                    maxQty={state.qtyRequired ? item.qty : 1}
                                    onSelectQty={(qty: number) => {
                                        console.log('qty');
                                        setSelectedItems(
                                            selectedItems.map(selectedItem =>
                                                selectedItem.item.id === item.id
                                                    ? {
                                                          item,
                                                          qty,
                                                      }
                                                    : selectedItem
                                            )
                                        );
                                    }}
                                    onSelect={() => {
                                        console.log('select');
                                        setSelectedItems([
                                            ...selectedItems,
                                            {
                                                item,
                                                qty: state.qtyRequired
                                                    ? item.qty
                                                    : null,
                                            },
                                        ]);
                                    }}
                                    onDeselect={() => {
                                        console.log('deselect');
                                        setSelectedItems(
                                            selectedItems.filter(
                                                selectedItem =>
                                                    selectedItem.item.id !==
                                                    item.id
                                            )
                                        );
                                    }}
                                    first={index === 0}
                                    last={
                                        index ===
                                        order.orderItems.filter(
                                            item => item.allowShipment
                                        ).length -
                                            1
                                    }
                                />
                            );
                        })}
                </CardContent>
            )}
            {state.items.length === 0 && (
                <CardFooter noHorizontalPadding={!cardsLayout}>
                    <Button
                        label={
                            selectedItems.length
                                ? 'Volgende'
                                : 'Selecteer minimaal 1 product'
                        }
                        rightIcon={isLoading ? Icons.LOADING : Icons.CH_RIGHT}
                        type={
                            selectedItems.length > 0 && !isLoading
                                ? 'primary'
                                : 'disabled'
                        }
                        onClick={() => {
                            setLoading(true);
                            setStateItems(selectedItems).finally(() => {
                                setLoading(false);
                            });
                        }}
                    />
                </CardFooter>
            )}
        </Card>
    );
};
